export default "__VITE_ASSET__vHsjL8Rm__"